import TableFilter from '@/components/common/tablefilter/TableFilter.vue'

export default {
  name: 'LogList',
  props: {
    isModal: Boolean,
    title: String,
    data: Array,
    pagingData: Object,
    itemName: String,
    reqPath: String,
    perPage: Number,
    filters: Object,
    filterValues: Object,
    loadUsers: {
      type: Boolean,
      default: false
    },
    periodId: {
      default: null,
      type: String | Number
    }
  },
  data () {
    return {
      configParamConfig: {
        clientReports: {
          'status-change': 'client_report_statuses'
        }
      },
      loading: false,
      logData: [],
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      loadedItemName: '',
      users: []
    }
  },
  components: {
    TableFilter
  },
  computed: {
    quickfilters () {
      const res = {};
      for (const key in this.filters) {
        if (!Object.prototype.hasOwnProperty.call(this.filters[key], 'colOnlyFilter') || this.filters[key].colOnlyFilter === false) {
          res[key] = this.filters[key];
        }
      }
      return res;
    },
    hasColFilters () {
      if (this.fields) {
        return (this.fields.filter(el => Object.prototype.hasOwnProperty.call(el, 'filterKey')).length > 0);
      }
      return false;
    },
    clientLogTypes () {
      return [
        'CLIENT-BASIC', 'CLIENT-CON', 'CLIENT-AGR', 'CLIENT-FILES',
        'CLIENT-BLK', 'CLIENT-MAT-CH', 'CLIENT-SET-CH', 'CLIENT-SET-NEW',
        'CLIENT-SET-DEL', 'CLIENT-AUDIT', 'CLIENT-AUDIT-SET',
        'CLIENT-BILL-DEL', 'CLIENT-BILL-ATTACH'
      ];
    },
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    configParameters () {
      return this.configParamConfig[this.itemName];
    },
    logRecordTypes () {
      return this.$store.getters.getDataFromConfigWithFilter('log_record_types', null, null);
    },
    tableHeaders () {
      const headers = [];
      headers.push({ key: 'type_id', label: this.$t('log.type'), filterKey: 'type', class: 'col-width-medium' });
      headers.push({ key: 'user.name', label: this.$t('log.user'), filterKey: 'user', class: 'col-width-medium' });
      headers.push({ key: 'created_at', label: this.$t('log.created'), filterKey: 'date', class: 'col-width-medium' });
      if (this.loadedItemName === 'materialrates') {
        headers.push({ key: 'client', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'client.api_id' } });
        headers.push({ key: 'material', label: this.$t('material.name') });
      } else if (this.loadedItemName === 'users') {
        headers.push({ key: 'modified_user.name', label: this.$t('log.users.modified_user'), filterKey: 'modifiedUser' });
      }
      headers.push({ key: 'oldValue', label: this.$t('log.oldValue'), valueChange: true });
      headers.push({ key: 'newValue', label: this.$t('log.newValue'), valueChange: true });
      return headers;
    }
  },
  methods: {
    show (logData) {
      if (logData) {
        this.logData = logData;
      }
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    },
    getStatusClass (statusId) {
      let itemConfig = this.$store.getters.getDataFromConfigWithFilter(this.configParameters['status-change'], null, null);
      if (itemConfig) {
        itemConfig = itemConfig[statusId];
      }
      if (itemConfig) {
        if (['REJECTED', 'DELETED'].includes(itemConfig.code)) {
          return 'error';
        }
        return 'success';
      }
    },
    getRouteParams (data) {
      const params = {};
      for (const [key, keyStr] of Object.entries(data.field.params)) {
        params[key] = this.BasicHelper.getObjectValueByString(data.item, keyStr);
      }
      return params;
    },
    getClientParamKeyVal (type) {
      if (type.indexOf('USER-') === 0) {
        return 'user.';
      }
      if (type === 'CLIENT-CON') {
        return 'contract.';
      }
      if (type.indexOf('CLIENT-BILL') === 0) {
        return 'bill.';
      }
      if (type === 'CLIENT-AUDIT' || type === 'CLIENT-AUDIT-SET') {
        return 'audit.';
      }
      if (type === 'CLIENT-AGR') {
        return 'contractAgreement.';
      }
      if (type.indexOf('MAT-CAT-') === 0) {
        return 'material-category.';
      }
      if (type.indexOf('MAT-GR-') === 0) {
        return 'material-group.';
      }
      if (type.indexOf('MAT-GEN-') === 0) {
        return 'material_rate.';
      }
      if (type.indexOf('MAT-') === 0) {
        return 'material.';
      }
      if (type.indexOf('CLIENT-SET-') === 0) {
        return 'client.materialgroupsettings.';
      }
      return 'client.';
    },
    formatVal (key, logRecType, value) {
      const configRemap = {
        material_group_id: 'material_groups',
        material_id: 'materials',
        measure_type_id: 'measure_types',
        parent_category_id: 'material_categories',
        material_category_id: 'material_categories',
        classification_group_id: 'customer_priority_classification_groups',
        tax_group_id: 'tax_groups',
        customer_payment_method_id: 'customer_payment_methods',
        payment_term_id: 'payment_terms',
        country_id: 'countries',
        currency_id: 'currencies',
        customer_group_id: 'customer_groups',
        locale_id: 'locales'
      }
      if (key === 'type_id' && logRecType.indexOf('CLIENT-SET-') === 0) {
        return this.BasicHelper.getConfigValue('client_setting_types', 'id', value, 'name', true);
      } else if (configRemap[key]) {
        return this.BasicHelper.getConfigValue(configRemap[key], 'id', value, 'name', true)
      } else if (key === 'manager_id') {
        return this.BasicHelper.getConfigValue('managers', 'id', value, 'name', false)
      } else if (key === 'axapt-block-time' || key === 'forceUnblockUntil') {
        return this.$options.filters.formatDate(value, this.$t('general.dateTimeFormat'));
      } else if (key === 'from_date_period_id' || key === 'to_date_period_id' || key === 'schedule_to_date_period_id') {
        if (value) {
          const datePer = this.BasicHelper.datePeriodCodeToData(value);
          return (datePer ? this.$tc('general.datePeriod.short', datePer.period, datePer) : '');
        }
      } else if (key === 'primary_filler_user_id' || key === 'disable_reason_user_id') {
        if (value && this.users[value]) {
          return this.users[value].name;
        }
        return '';
      } else if (key === 'disabled' || key === 'deleted' || key === 'isResident' || key === '') {
        if (value) {
          return this.$t('general.yes');
        }
        return this.$t('general.no');
      } else if (key === 'name' && (typeof value === 'object')) {
        let resStr = '';
        for (const locale in value) {
          if (resStr !== '') {
            resStr += ', ';
          }
          resStr += locale + ': "' + value[locale] + '"';
        }
        return resStr;
      }
      return value;
    },
    reload () {
      this.changePage(this.paging.page);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.logData = [];
      this.loading = true;
      this.$forceUpdate();
      const self = this;
      let pathParam = '?';
      if (this.reqPath.indexOf('?') > 0) {
        pathParam = '&';
      }
      let path = this.reqPath + pathParam + 'perPage=' + this.paging.limit + '&page=' + pageNr;
      path = this.ApiRequest.addGetParamsToPath(path, this.getFilterValues(), true);
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.loadedItemName = self.itemName;
          self.logData = response.data;
          self.paging.limit = response.paging.limit;
          self.paging.total = response.paging.total;
          self.paging.page = response.paging.page;
          self.paging.pages = response.paging.pages;
        }
        self.loading = false;
        self.$forceUpdate();
      })
    },
    getFilterValues () {
      return this.filterValues;
    },
    getReportApproveErrorMsg (type, params) {
      if (params && params.material_id) {
        params.material = this.BasicHelper.getTranslation(this.$store.getters.getParamFromConfig('materials', params.material_id, 'name'));
      }
      if (type === 'EMPTY_LASTX') {
        return this.$tc('report.approve-error.' + type, params.filledInLast, params);
      }
      return this.$t('report.approve-error.' + type, params);
    }
  },
  mounted () {
    if (this.perPage) {
      this.paging.limit = this.perPage;
    }
    this.loadedItemName = this.itemName;
    if (this.data) {
      this.logData = this.data;
      this.paging = this.pagingData;
    } else if (this.reqPath) {
      this.changePage(this.paging.page);
    }
    if (this.loadUsers) {
      const self = this;
      this.ApiRequest.request('user/optionlist', this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.users = response.data;
        }
      });
    }
  }
}
